import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElGallery, ElGalleryContent, ElColumn, elGapGallery, elBgWhite, ElImageBox } from "./gallery.css";
import { Container } from "../../layout";
import { ElCriteriaContent, ElFooterContent } from "../criteria";
import { elFlexAlignCenter, elFlexJustifyCenter, elFlexNoWrap } from "../../../@css-style";
import { ElAnchorButton, ElDetails, ElHeadLine, ElHeadLineBig } from "../head-title";
import { cx } from "@linaria/core";

interface IGalleryProps extends HTMLAttributes<HTMLElement> {
  images: string[];
  link: string;
}

export const Gallery: FC<IGalleryProps> = ({ children, images, ...props }) => {
  return (
    <ElGallery {...props}>
      <Container className={elGapGallery}>
        <ElGalleryContent>
          <ElHeadLine style={{ "--hashTag": `"#EXPLORE PROGRAM"` }}>Kaleidoskop BEKUP Accelerate</ElHeadLine>
        </ElGalleryContent>
        <ElGalleryContent>
          <ElColumn className={elBgWhite}>
            <ElImageBox>
              <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/gallery/galery-1.png' alt="" />
            </ElImageBox>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <ElImageBox>
              <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/gallery/galery-2.png' alt="" />
            </ElImageBox>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <ElImageBox>
              <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/gallery/galery-3.png' alt="" />
            </ElImageBox>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <ElImageBox>
              <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/gallery/galery-4.png' alt="" />
            </ElImageBox>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <ElImageBox>
              <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/gallery/galery-5.png' alt="" />
            </ElImageBox>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <ElImageBox>
              <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/gallery/galery-6.png' alt="" />
            </ElImageBox>
          </ElColumn>
        </ElGalleryContent>

        <ElCriteriaContent>
          <ElHeadLineBig className={elFlexJustifyCenter}>
            <span> Be part of the Thrilling</span> <span>BEKUP Accelerate 2025 program!</span>
          </ElHeadLineBig>
        </ElCriteriaContent>
        <ElCriteriaContent className={cx(elFlexJustifyCenter, elFlexNoWrap, elFlexAlignCenter)}>
          <ElFooterContent>
            <ElAnchorButton href={props.link} target="_blank">
              Daftar Disini
            </ElAnchorButton>
          </ElFooterContent>
        </ElCriteriaContent>
      </Container>
    </ElGallery>
  );
};
